import * as React from "react";
// tslint:disable-next-line:no-implicit-dependencies
import {Subscription} from "rxjs";
import {
    POPUP_STATE,
    PopupController,
} from "./PopupController";

import "./PopupStyle.scss";

export interface PopupProps {
    controller: PopupController;
    className?: string;
    child?: any;
}

export interface PopupState {
    content: any;
}

export class Popup extends React.Component<PopupProps, PopupState> {

    private listener: Subscription;

    constructor(props) {
        super(props);
        this.state = {
            content: this.props.child,
        };
    }

    public componentDidMount() {
        this.listener = this.props.controller.listen((state) => {
            switch (state) {
                case POPUP_STATE.OPEN: {
                    this.setState({
                        content: this.props.controller.content,
                    });
                    break;
                }
                case POPUP_STATE.CLOSE: {
                    this.setState({
                        content: null,
                    });
                    break;
                }
            }
        });
    }

    public componentWillUnmount() {
        if (this.listener) {
            this.listener.unsubscribe();
        }
    }

    public render() {
        return this.state.content ?
            (
                <div className={"dashboard-popup " + (this.props.className || "")}>
                    <div className="popup-overlay" onClick={this.onBackgroundClicked}/>
                    <div className="popup-window">
                        {typeof this.state.content === "function"
                            ? this.state.content()
                            : this.state.content
                        }
                    </div>
                </div>
            ) : null;
    }

    private onBackgroundClicked = (e) => this.props.controller.onBackgroundClicked();
}
